import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  CREATE_TEMPLATE_SERVICE,
  GET_TEMPLATE_BY_ID,
  GET_TEMPLATES,
  GET_WHATSAPP_TEMPLATE_LIBRARY,
} from '../../../api/wca/wca.template.services.js';

export const getTemplates_WCA = createAsyncThunk(
  'template/getTemplates',
  async ({ metadataid, pageNo = 0, limit = 30, status }, thunkAPI) => {
    try {
      const response = await GET_TEMPLATES(metadataid, pageNo, limit, status);
      console.log('response', response);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const createTemplate_WCA = createAsyncThunk(
  'template/createTemplate',
  async ({ metadataid, data }, thunkAPI) => {
    try {
      const response = await CREATE_TEMPLATE_SERVICE(metadataid, data);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const getTemplateById_WCA = createAsyncThunk(
  'template/getTemplateById',
  async ({ metadataid, templateID, templateName }, thunkAPI) => {
    try {
      const response = await GET_TEMPLATE_BY_ID(metadataid, templateID, templateName);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const deleteTemplate_WCA = createAsyncThunk(
  'template/deleteTemplate',
  async ({ elementName }, thunkAPI) => {
    return;

    // try {
    //   const resp = await axiosInstance.delete(
    //     `/whatsappTemplate/gupshup/${elementName}`
    //   );
    //   return elementName;
    // } catch (error) {
    //   return thunkAPI.rejectWithValue(error.response.data);
    // }
  },
);

export const getWhatsAppTemplateLibrary_WCA = createAsyncThunk(
  'template/getWhatsAppTemplateLibrary',
  async (
    {
      metadataid,
      search = '',
      topic = 'ALL',
      usecase = 'ALL',
      industry = 'ALL',
      language = 'en',
      after = '',
    },
    thunkAPI,
  ) => {
    try {
      const response = await GET_WHATSAPP_TEMPLATE_LIBRARY(metadataid, {
        search,
        topic,
        usecase,
        industry,
        language,
        after,
      });
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err?.message || err);
    }
  },
);
